import http from './http';
import user from '@/common/user';
import { getTime } from '@/common/utils';
import IO from '@/config/api-config';

export default {
  async checkStoreInfo(cb) {
    const storeInfo = user.getUserInfo('soreInfo');
    if (!storeInfo) {
      await this.getSoreInfo();
    }
    cb && cb();
  },
  async getStoreInfo() {
    let storeInfo = user.getUserInfo('soreInfo') || '';
    if (!storeInfo) {
      storeInfo = await this.getSoreInfo();
    }
    return storeInfo;
  },
  getStockInfo(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_stock_info', params });
  },
  getStockList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_stock_list', params });
  },
  getStockDetail(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_stock_detail', params });
  },
  getOutStockList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_out_stock_list', params });
  },
  getBarCode(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_bar_code', params });
  },
  putInStock(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'put_in_stock', params });
  },
  getStockNumList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_stock_num_list', params });
  },
  confirmDelivery(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'confirm_delivery', params });
  },
  sendStockItem(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'send_stock_item', params });
  },
  getSendStockDetail(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_send_stock_detail', params });
  },
  getDeliveryList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_delivery_list', params });
  },
  getClerkInfo(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_clerk_info', params });
  },
  getOrderList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_order_list', params });
  },
  getFollowList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_follow_list', params });
  },
  submitFollow(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'submit_follow', params });
  },
  getBusinessData(params = {}) {
    let timer = getTime();
    params = Object.assign(
      {
        startDate: `${timer.y}-${timer.m}-${timer.d}`,
        endDate: `${timer.y}-${timer.m}-${timer.d}`
      },
      params
    );
    return http.fetch({ _interface: 'get_business_data', params });
  },
  getHotModelList(params = {}) {
    let timer = getTime();
    params = Object.assign(
      {
        startDate: `${timer.y}-${timer.m}-${timer.d}`,
        endDate: `${timer.y}-${timer.m}-${timer.d}`
      },
      params
    );
    return http.fetch({ _interface: 'get_hot_model_list', params });
  },
  async getClerkList(params = {}) {
    if (!params.storeId) {
      const storeId = user.getUserInfo('storeId');
      if (storeId) {
        params.storeId = storeId;
      } else {
        await this.getSoreInfo();
        const storeId = user.getUserInfo('storeId');
        params.storeId = storeId;
      }
    }
    params = Object.assign(
      {
        pageIndex: '0',
        pageSize: '100'
      },
      params
    );
    return http.fetch({ _interface: 'get_clerk_list', params });
  },
  async getStoreWorkerList(params = {}) {
    if (!params.storeId) {
      const storeId = user.getUserInfo('storeId');
      if (storeId) {
        params.storeId = storeId;
      } else {
        await this.getSoreInfo();
        const storeId = user.getUserInfo('storeId');
        params.storeId = storeId;
      }
    }
    params = Object.assign({}, params);
    return http.fetch({ _interface: 'get_store_worker_list', params });
  },
  async getSoreInfo(storeId) {
    storeId = storeId || user.getUserInfo('storeId');
    if (!storeId) {
      console.log('获取店铺信息失败，缺失storeId');
      return false;
    }
    let params = {
      storeId
    };
    try {
      let rs = await http.fetch({ _interface: 'get_store_info', params });
      if (rs.data) {
        user.setUserInfo({
          soreInfo: rs.data
        });
      }
      return rs.data;
    } catch (error) {
      console.log(error);
    }
  },
  get_help_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_help_list', params });
  },
  get_help_content(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_help_content', params });
  },
  phone_call_out(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'phone_call_out', params });
  },
  get_login_captcha(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_login_captcha',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  login_captcha(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'login_captcha',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  merge_payments_sumit_order(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'merge_payments_sumit_order', params });
  },
  feedback_type_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'feedback_type_list', params });
  },
  feedback_submit(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'feedback_submit', params });
  },
  old_change_new_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'old_change_new_list', params });
  },
  store_user_pull_the_new(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'store_user_pull_the_new', params });
  },
  pull_up_the_leaderboard(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'pull_up_the_leaderboard', params });
  },
  get_coupon_info(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_coupon_info', params });
  },
  check_coupon_id(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'check_coupon_id', params });
  },
  get_order_sceening_data(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_order_sceening_data', params });
  },
  get_common_order_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_common_order_list', params });
  },
  get_search_history(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_search_history', params });
  },
  commodity_saul_built_single_code(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'commodity_saul_built_single_code',
      params
    });
  },
  auto_salse_order_confirm(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'auto_salse_order_confirm', params });
  },
  order_operation(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'order_operation', params });
  },
  get_new_follow_count(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_new_follow_count', params });
  },
  xy_recycling_data(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'xy_recycling_data', params });
  },
  xy_stores_sales(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'xy_stores_sales', params });
  },
  xy_process_service(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'xy_process_service', params });
  },
  // 质检数据
  get_detect_info(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_detect_stats',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 标准检测未发生列表
  unsent_detect_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_unsent_detect_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 标准检测已发送列表
  sent_detect_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_sent_detect_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 待拍照列表
  take_pic_detect_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_takepic_detect_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 大检测检测列表
  oms_detect_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_oms_detect_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 搜索记录
  search_dDetect_lList(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'search_detect_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 关注
  add_user_favor_product(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'add_user_favor_product',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 用户注册申请
  user_register_apply(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'user_register_apply',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 取消关注
  del_user_favor_product(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'del_user_favor_product',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 获取用户关注机型列表
  get_user_favor_product_list(params = {}, options = {}) {
    params = Object.assign(params, {});
    return http.fetch(
      {
        _interface: 'get_user_favor_product_list',
        params,
        path: `${IO.hsbproUrl}/hsbpro`
      },
      options
    );
  },
  // 报价热门机型列表
  quote_hot_product_list(params = {}, options = {}) {
    params = Object.assign(params, {});
    return http.fetch(
      {
        _interface: 'quote_hot_product_list',
        params,
        path: `${IO.hsbproUrl}/hsbpro`
      },
      options
    );
  },
  // 获取价格动态
  get_message_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_message_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 报价品牌列表
  quote_brand_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'quote_brand_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 获取成色列表
  quote_quality_list(params = {}) {
    params = Object.assign(
      {
        type: '2'
      },
      params
    );
    return http.fetch({
      _interface: 'quote_quality_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 获取产品SKU组合
  product_sku(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'product_sku',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 报价机型搜索
  quote_product_search(params = {}, options = {}) {
    params = Object.assign(params, {});
    return http.fetch(
      {
        _interface: 'quote_product_search',
        params,
        path: `${IO.hsbproUrl}/hsbpro`
      },
      options
    );
  },
  // 报价机型详情接口
  quote_product_detail(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'quote_product_detail',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 报价来源列表
  quote_product_source(params = {}) {
    params = Object.assign(params, {
      status: '1',
      keyword: '',
      pageIndex: '0',
      pageSize: '500'
    });
    return http.fetch({
      _interface: 'quote_source_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 报价机型趋势接口
  quote_product_trend(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'quote_product_trend',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 省市区
  city_getAll(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'city_getAll',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 获取图片上传密钥（腾讯云）
  get_upload_sign(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({ _interface: 'get_upload_sign', params });
  },
  // imei充值-获取支付参数
  imei_recharge(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'imei_recharge',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 保证金充值-获取支付参数
  cash_deposit_recharge(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'cash_deposit_recharge',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 上拍保证金充值-获取支付参数
  cash_sale_deposit_recharge(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'cash_sale_deposit_recharge',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 获取工程师派单日历
  get_engineer_calendar(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_engineer_calendar',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 设置工程师派单日历
  update_engineer_calendar(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'update_engineer_calendar',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 预付货款支付
  prepay_payment(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'prepay_payment',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 用户申请上门角色
  user_card_check(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'user_card_check',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 获取来源列表
  quote_source_list(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'quote_source_list',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 查询用户身份审核状态
  get_user_card_check_status(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'get_user_card_check_status',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 身份证实名认证
  authentication(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'authentication',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 检测三期质检报告
  get_detect_v3_report(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'detect_v3_get_result',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  },
  // 检测三期设备详情
  get_detect_v3_device_detail(params = {}) {
    params = Object.assign(params, {});
    return http.fetch({
      _interface: 'detect_v3_get_device_detail',
      params,
      path: `${IO.hsbproUrl}/hsbpro`
    });
  }
};
